import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {SimpleDropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {useLinkNavigation} from '../../../../../../libs/shared/ui/src/components/navigation/useLinkNavigation';
import {PopoverCoordinator} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {PermissionsEnum} from '../../../../../models/api/roleModel';
import {getHasPermission} from '../../../../../store/data/access/accessSelectors';
import {ActivityRuleOrMacroPillProps} from './activityRuleOrMacroPill';
import {
  StyledActivityRulePillDiv,
  StyledActivityRulePillLearnMoreDiv,
  StyledActivityRulePillLinkIcon,
  StyledActivityRulePillTooltipContentIcon,
} from './activityRulePillHelpers';

/*
 * Props.
 */

interface ActivityMacroPillProps extends ActivityRuleOrMacroPillProps {}

/*
 * Component.
 */

export const ActivityMacroPill: FC<ActivityMacroPillProps> = (props) => {
  const {ruleBundleId, ruleNamespace, ruleName} = props;
  const hasPermission = useAppSelector(getHasPermission);
  const {navigateToLink} = useLinkNavigation();
  if (!ruleNamespace) {
    return null;
  }

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => (
        <TooltipCoordinator
          render={() => (
            <>
              <StyledActivityRulePillTooltipContentIcon name="lightningTiny" />
              {ruleName}
            </>
          )}
        >
          <StyledActivityRulePillDiv isOpen={isOpen}>
            <StyledActivityRulePillTooltipContentIcon name="lightningTiny" />
            {ruleName}
          </StyledActivityRulePillDiv>
        </TooltipCoordinator>
      )}
      renderModal={(popoverProps) => (
        <Dropdown {...popoverProps} maxWidth={205}>
          <DropdownList {...popoverProps}>
            <SimpleDropdownItem
              isDisabled={!hasPermission(ruleNamespace, PermissionsEnum.EDIT_RULE) || !ruleBundleId}
              onSelect={() =>
                navigateToLink(
                  `/settings/${ruleNamespace}/rules/macros/edit/${ruleBundleId}?isRuleBundleId=true`,
                )
              }
            >
              <Trans id="activity-rule-macro-pill-edit">Edit macro</Trans>
            </SimpleDropdownItem>
            <SimpleDropdownItem onSelect={() => navigateToLink('https://help.front.com/en/articles/824576')}>
              <StyledActivityRulePillLearnMoreDiv>
                <Trans id="activity-rule-macro-pill-help">
                  Learn more about macros <StyledActivityRulePillLinkIcon name="externalLinkSmall" />
                </Trans>
              </StyledActivityRulePillLearnMoreDiv>
            </SimpleDropdownItem>
          </DropdownList>
        </Dropdown>
      )}
    />
  );
};
